import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import './desktop-only.sass'

@Component
export class DesktopOnly extends Vue {

  render (h: CreateElement) {
    return (
      <div class='desktop-only'>
        {this.$slots.default}
      </div>
    )
  }

}
